import { memo } from "react";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import { copyToClipboard } from "@core/utils/string";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Button from "@components/Button";

const ProviderLinkInput = ({
    label,
    value,
    onChange,
}: {
    label: string;
    value: string;
    onChange: (value: string) => void;
}) => (
    <div className="SurveyDetails__form-column">
        <span className="SurveyDetails__label">{label}:</span>
        <div className="SurveyDetails__form-item-row">
            <TextField
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder="https://..."
                size="small"
                fullWidth
                classes={{
                    root: 'FloatInput',
                }}
                InputProps={{
                    classes: {
                        root: 'FloatInput__root--small',
                        input: 'FloatInput__input',
                    }
                }} />
                
            <Button
                modifiers={['naked']}
                className="SurveyDetails__copy-button"
                onClick={() => {
                    copyToClipboard(value ?? '');
                    toast.success(`${label} link copied!`);
                }}
            >
                <ContentCopyIcon />
            </Button>
        </div>
    </div>
);

export default memo(ProviderLinkInput);